import { IExercise } from '../../types/interfaces/exercise';
import React, { ReactNode } from 'react';
import { Box } from '@mui/material';
import AppButton from '../../components/designe/app-button/AppButton';
import {
  useExercisePublicApprove,
  useExercisePublicReject,
} from '../../services/redux/api/exercisesAPI';
import { useTranslation } from 'react-i18next';
import { AppBarWithActionButtons } from '../../components/designe/app-bar-with-buttons/AppBarWithActionButtons';
import { useAccess } from '../../hooks/useAccess';
import { ExerciseScope } from '../../shared/constants';

export function useExercise() {
  const [approveRequest] = useExercisePublicApprove();
  const [rejectRequest] = useExercisePublicReject();
  const { t } = useTranslation();
  const { access } = useAccess();

  function canDelete(exercise: IExercise) {
    return !exercise?.ownerId && (access?.exercises?.canDelete ?? false);
  }

  function canEdit(exercise: IExercise) {
    return !exercise?.ownerId && (access?.exercises?.canEdit ?? false);
  }

  function canChangeStatus(exercise: IExercise) {
    return (
      exercise?.ownerId && (access?.exercisePostings?.canChangeStatus ?? false)
    );
  }

  function renderExerciseActionButton(
    exercise: IExercise,
    onEditClick?: (id: string) => void,
    onDeleteClick?: (id: string) => void,
  ): ReactNode[] | ReactNode {
    return (
      <Box display="flex" justifyContent="flex-end" gap={1}>
        <AppBarWithActionButtons
          onEditClick={
            canEdit(exercise) && onEditClick && (() => onEditClick(exercise.id))
          }
          onDeleteClick={
            canDelete(exercise) &&
            onDeleteClick &&
            (() => onDeleteClick(exercise.id))
          }
        />
        {canChangeStatus(exercise) && (
          <>
            {exercise.scope === ExerciseScope.publicRequest && (
              <AppButton
                variant="contained"
                onClick={() => approveRequest(exercise.id)}>
                {t('exercises.approve')}
              </AppButton>
            )}
            {(exercise.scope === ExerciseScope.public ||
              exercise.scope === ExerciseScope.publicRequest) && (
              <AppButton
                variant="contained"
                color="error"
                onClick={() => rejectRequest(exercise.id)}>
                {t('exercises.reject')}
              </AppButton>
            )}
          </>
        )}
      </Box>
    );
  }

  return { renderExerciseActionButton };
}
